import Matomo from '../common/utils/matomo';
import { getMatomoOptions } from './branding';

const tracker = new Matomo(getMatomoOptions());

export default tracker;
